import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheResonance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="1288" id="precision-aviation-elevated" className="dark bg-background text-foreground relative min-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618318/img/private_jet.png" alt="Private jet flying in the air" className="absolute inset-0 w-full h-full object-cover" />
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/80 to-black/40" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h1 className="font-sans text-5xl md:text-7xl lg:text-[90px] font-extrabold tracking-tighter leading-[1.05] text-white mb-6 uppercase">Starboard Aviation Group</h1>

        <p className="text-lg md:text-xl text-[#A1A1A1] max-w-2xl mx-auto mb-10 font-light tracking-wide">Your private aviation partner, delivering discreet, white-glove consulting, operational expertise, and seamless end-to-end solutions</p>

        <div className="max-w-md mx-auto mb-10 w-full px-4">
          
        </div>

        <div className="flex justify-center">
          <Button asChild size="lg" className="relative bg-[#FF5F1F] hover:bg-[#e6551a] text-white font-bold text-lg px-10 py-7 rounded-none shadow-[0_0_20px_rgba(255,95,31,0.4)] hover:shadow-[0_0_30px_rgba(255,95,31,0.6)] transition-all duration-300 group overflow-hidden">
            <Link to="#secure-your-flight">
              <span className="relative z-10">Request a Flight</span>
              {}
              <span className="absolute inset-0 rounded-none ring-2 ring-white/30 animate-ping opacity-75 duration-1000" />
              {}
              <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-0" />
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3 opacity-80">
        <span className="text-xs uppercase tracking-[0.3em] text-[#A1A1A1] font-medium">
          Scroll to Explore
        </span>
        <div className="h-16 w-[1px] bg-white/10 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1/2 bg-[#FF5F1F] animate-[drop_2s_infinite]" />
        </div>
      </div>

      {}
      <style jsx global>{`
        @keyframes shine {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
        .animate-shine {
          animation: shine 4s linear infinite;
        }
        @keyframes drop {
          0% {
            top: -100%;
          }
          100% {
            top: 100%;
          }
        }
        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </section>;
}